import type { WebchatTranslations } from '.'

export const it: WebchatTranslations = {
  'composer.placeholder': 'Scrivi il tuo messaggio...',
  'composer.sendButton.ariaLabel': 'Pulsante Invia messaggio',
  'composer.voiceButton.ariaLabel': 'Pulsante Inserimento vocale',
  'composer.fileButton.ariaLabel': 'Pulsante Carica file',
  'composer.messageInput.ariaLabel': 'Campo di inserimento messaggio',

  'fileAttachment.uploadError': 'Errore di caricamento',
  'fileAttachment.fallbackExtension': 'File',
  'fileAttachment.removeButton.ariaLabel': 'Pulsante Rimuovi file',

  'header.defaultBotName': 'Bot',
  'header.expandButton.ariaLabel': 'Pulsante Espandi intestazione',
  'header.sound.enable': 'Attiva suoni della chat',
  'header.sound.disable': 'Disattiva suoni della chat',

  'conversationHistory.title': 'Conversazioni',
  'conversationHistory.empty': 'Nessuna conversazione avviata',
  'conversationHistory.newConversation': 'Nuova conversazione',
  'conversationHistory.sentAttachment': 'Ha inviato un allegato',
  'conversationHistory.showButton.ariaLabel': 'Pulsante Mostra conversazioni recenti',

  'restartConversation.title': 'Crea nuova conversazione',
  'restartConversation.description': 'Questo cancellerà la conversazione corrente e ne avvierà una nuova.',
  'restartConversation.confirm': 'Nuova conversazione',
  'restartConversation.cancel': 'Annulla',
  'restartConversation.button.ariaLabel': 'Pulsante Riavvia conversazione',

  'closeButton.ariaLabel': 'Pulsante Chiudi chatbot',

  'feedback.title': 'Aiutaci a migliorare',
  'feedback.description': 'Inviaci il tuo feedback per aiutarci a migliorare.',
  'feedback.confirm': 'Invia feedback',
  'feedback.cancel': 'Annulla',
  'feedback.placeholder': 'Dicci cosa non ha funzionato...',

  'error.configuration': 'Errore di configurazione',
  'error.bot': 'Errore del bot',
  'error.network': 'Errore di rete',
  'error.disconnected': 'Disconnesso',
  'error.unexpected': 'Errore imprevisto',

  'dropdown.placeholder': 'Seleziona...',
}
